/*
  Ежемесячный отчёт руководителю — §3.11.4.

  Четыре раздела идут в порядке, который задал сервер, и переставлять их
  здесь нельзя: они читаются как повестка разговора - что сделано, что
  вернулось, что горит, какие решения ждут.

  Ноль показывается нулём, а неизмеренная величина - прочерком. Это разные
  вещи: ноль означает, что за месяц не сделано ничего, прочерк - что показатель
  к этой строке не относится (у «подано заявлений» нет суммы). Подменить одно
  другим значило бы соврать руководителю в отчёте, который он подошьёт.
*/

import { money } from '../api/format.js'
import PageBar from './PageBar.jsx'
import usePaging from './usePaging.js'

function LineRow({ line }) {
  return (
    <tr>
      <td>
        {line.title}
        {line.note ? <div className="muted">{line.note}</div> : null}
      </td>
      <td className="table__num" data-label="Количество">
        {line.count === null ? '-' : line.count}
      </td>
      <td className="table__num" data-label="Сумма">
        {line.amount === null ? '-' : money(line.amount)}
      </td>
    </tr>
  )
}

/*
  Раздел отчёта - своим компонентом, чтобы у каждого была своя панель страниц (21.10.2026,
  замечание владельца: число записей и страницы под любой таблицей). Показатели - расчёт
  сервера за месяц, своей точки со страницами у них нет: панель листает их в браузере.
*/
function ReportSection({ section }) {
  const { rows, bar } = usePaging(section.lines)
  return (
    <section className="section">
      <h2 className="section__title">{section.title}</h2>
      <div className="card">
        <div className="table-scroll">
          {/*
            Ширина колонок задана одинаково во всех четырёх разделах
            (`table--report`, 08.09.2026, замечание владельца). Браузер считает
            её по содержимому каждой таблицы отдельно, и колонка «количество»
            стояла в каждом разделе на своём месте: числа гуляли по экрану от
            блока к блоку, хотя означают одно и то же.
          */}
          <table className="table table--report">
            <thead>
              <tr>
                <th>Показатель</th>
                <th className="table__num">Количество</th>
                <th className="table__num">Сумма</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((line) => (
                <LineRow key={line.title} line={line} />
              ))}
            </tbody>
          </table>
        </div>
        <PageBar {...bar} what="показателей" />
      </div>
    </section>
  )
}

export default function MonthlyReport({ report }) {
  return (
    <>
      {report.sections.map((section) => (
        <ReportSection key={section.key} section={section} />
      ))}
    </>
  )
}
